<template>
  <div class="main user-layout-register">
    <h3><span>修改密码</span></h3>
    <a-form ref="formRegister" :form="form" id="formRegister">
      <div>
        <a-form-item>
          <a-input
            size="large"
            v-decorator="[
              'phonenumber',
              {
                rules: [{ required: true, message: '请输入正确的手机号', pattern: /^1[3456789]\d{9}$/ }],
                validateTrigger: ['change', 'blur']
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="16">
            <a-form-item>
              <a-input
                size="large"
                type="text"
                v-decorator="[
                  'verifyCode',
                  { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }
                ]"
              >
                <img slot="prefix" src="/loginImg/authCode.png" style="width: 15px" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button
              class="getCaptcha"
              tabindex="-1"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getCaptcha"
              style="color: #999999"
              v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
            ></a-button>
          </a-col>
        </a-row>
        <a-form-item>
          <a-input
            size="large"
            type="password"
            @click="handlePasswordInputClick"
            autocomplete="false"
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: '至少6位密码，区分大小写' },
                  { validator: this.handlePasswordLevel }
                ],
                validateTrigger: ['change', 'blur']
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            type="password"
            v-decorator="[
              'password2',
              {
                rules: [
                  { required: true, message: '至少6位密码，区分大小写' },
                  { validator: this.handlePasswordLevel }
                ],
                validateTrigger: ['change', 'blur']
              }
            ]"
          ></a-input>
        </a-form-item>
      </div>
      <a-form-item>
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="register-button"
          :loading="registerBtn"
          @click="handleSubmit"
          :disabled="registerBtn"
          >提交
        </a-button>
        <router-link class="login" :to="{ name: 'login' }">使用已有账户登录</router-link>
      </a-form-item>
    </a-form>
    <a-popover
      style="position: absolute;top: 282px;left: 856px;"
      placement="rightTop"
      :trigger="['focus']"
      :getPopupContainer="trigger => trigger.parentElement"
      v-model="state.passwordLevelChecked"
    >
      <template slot="content">
        <div :style="{ width: '240px' }">
          <div :class="['user-register', passwordLevelClass]">
            强度：<span>{{ passwordLevelName }}</span>
          </div>
          <a-progress :percent="state.percent" :showInfo="false" :strokeColor="passwordLevelColor" />
          <div style="margin-top: 10px;">
            <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
          </div>
        </div>
      </template>
    </a-popover>
  </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import { getselectAllProvince, getselectCityName, getselectAreaName } from '@/api/enterprise/enterprise'
import { getInstallType, registrationCode, addEmployee, addEnterprise, sendIdCode2, sendIdCode,forgetPwd } from '../../api/login'

const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
export default {
  name: 'Recover',
  components: {},
  mixins: [mixinDevice],
  data() {
    return {
      form: this.$form.createForm(this),

      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      registerBtn: false,
      provinceMap: [],
      cityMap: [],
      areaArr: [],
      installTypeMap: [],
      registerType: '',
      isAble: false,
      phone: undefined
    }
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel]
    }
  },
  async created() {
    this.form.resetFields()
    // 省
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        res.rows.forEach(province => {
          this.provinceMap.push({ value: province.provinceCode, label: province.provinceName })
        })
      }
    })

    // 安装类型
    this.installTypeArr = await getInstallType('install_type')
    this.installTypeArr.rows.forEach(data => {
      this.installTypeMap.push({ value: data.dictValue, label: data.dictLabel })
    })
    // const validateFieldsKey = customActiveKey === 'tab1' ? ['phonenumber', 'password', 'verifyCode'] : ['mobile', 'verifyCode']
  },
  methods: {
    getCaptcha(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this

      validateFields(['phonenumber'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          sendIdCode({ mobile: values.phonenumber })
            .then(res => {
              if (res.code === 0) {
                this.$message.success('验证码获取成功')
              }else{
              this.$message.error(res.msg)
              }
              setTimeout(hide, 2500)
            })
            .catch(res => {
              this.$message.error(res.msg)
            })
        }
      })
    },

    handlePasswordLevel(rule, value, callback) {
      let level = 0

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback(new Error('密码强度不够'))
      }
    },
    handlePasswordCheck(rule, value, callback) {
      const password = this.form.getFieldValue('password')
      console.log('value', value)
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },

    handlePhoneCheck(rule, value, callback) {
      console.log('handlePhoneCheck, rule:', rule)
      console.log('handlePhoneCheck, value', value)
      console.log('handlePhoneCheck, callback', callback)

      callback()
    },

    handlePasswordInputClick() {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true
        return
      }
      this.state.passwordLevelChecked = false
    },
    changeProvince(e) {
      this.cityMap = []
      this.areaArr = []
      this.form.setFieldsValue({
        cityId: '',
        districtId: ''
      })
      // 市
      this.province = { provinceCode: e }
      getselectCityName(this.province).then(res => {
        if (res.code === 0) {
          res.rows.forEach(city => {
            this.cityMap.push({ value: city.cityCode, label: city.cityName })
          })
        }
      })
    },
    changeCity(e) {
      this.areaArr = []
      this.form.setFieldsValue({
        districtId: ''
      })
      // 区
      this.city = { cityCode: e }
      getselectAreaName(this.city).then(res => {
        if (res.code === 0) {
          res.rows.forEach(area => {
            this.areaArr.push({ value: area.areaCode, label: area.areaName })
          })
        }
      })
    },
    staffRegister() {
      this.registerType = '0'
    },
    enterpriseRegister() {
      this.registerType = '1'
      this.form.resetFields()
    },
    verification() {
      this.form.validateFields((err, values) => {
        if (!err) {
          registrationCode(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('验证成功')
                this.registerType = '2'
                this.isAble = true
                this.$nextTick(() => {
                  this.form.setFieldsValue({
                    phone: values.phoneNumber
                  })
                })
              }
              if (res.code === 500) {
                this.$message.error(res.msg)
              }
            })
            .catch(res => {
              this.$message.error(res.msg)
            })
        }
      })
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (values.password != values.password2) {
          this.$message.success('密码不一致')
        } else {
          if (!err) {
            console.log('values', values)

            forgetPwd(values).then(res => {
              if (res.code === 0) {
                this.$message.success('修改成功')
                this.$router.push({ name: 'login' })
              }
              if (res.code === 500) {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
        duration: 4
      })
      this.registerBtn = false
    }
  },
  watch: {
    'state.passwordLevel'(val) {
      console.log(val)
    }
  }
}
</script>
<style lang="less" scoped>
.user-register {
  &.error {
    color: #ff0000;
  }

  &.warning {
    color: #ff7e05;
  }

  &.success {
    color: #52c41a;
  }
}

.user-layout-register {
  .ant-input-group-addon:first-child {
    background-color: #fff;
  }
}
</style>
<style lang="less" scoped>
.user-layout-register {
  & > h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .register-button {
    width: 50%;
  }

  .login {
    float: right;
    line-height: 40px;
  }
}
</style>
